import { call, put, takeEvery } from 'redux-saga/effects';
import API from '../../API';
import { toastr } from 'react-redux-toastr';
import axios from 'axios';


async function getApi(data) {
    const apiUrl = API.baseURL + `/notification_count`;
    try {
        const response = axios.get(apiUrl, API.options)
        return await response;
    } catch (error) {
        throw error;
    }
}

function* getNotificationCount(action) {
    try {
        const response = yield call(getApi, action.data);
        if (response.data.code == 200 || response.data.code == 201) {
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
        } else {
            // response.errors.length!=0&&toastr.error('Pegister personal  failed', response.errors[0]);
        }
        // history.push('/');
        yield put({ type: 'GET_NOTIFICATION_COUNT_SUCCESS', data: response.data.data.count });
    } catch (e) {
        yield put({ type: 'GET_NOTIFICATION_COUNT_FAILED', message: e.message });
    }
}

function* notificationCountSaga() {
    yield takeEvery('GET_NOTIFICATION_COUNT_REQUESTED', getNotificationCount);
}

export default notificationCountSaga;